
import React from "react";
import AppRoutes from "@routes";
import "./index.css"; // keep your global css

export default function App() {
  return <AppRoutes />;
}

